// src/config.ts

// In production on autojourn.cloud, this will become https://autojourn.cloud/api
// For local dev, you can temporarily change this to "http://localhost:8000"
export const API_BASE_URL = "/api";
